import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.config.productionTip = false;
Vue.component('vue-phone-number-input', VuePhoneNumberInput);


new Vue({
  store,
  router,
  i18n,
  VuePhoneNumberInput,
  render: h => h(App)
}).$mount('#app')
